import React from "react";

export default class ReasonForm extends React.Component {

    state = {
        reason: "",
        error: false
    }

    constructor(){
        // assign ref to the textarea to give it focus
        super();
        this.textRef = React.createRef();
    }

    componentDidMount() {
        this.textRef.current.focus();
    }

    change = (evt) => {
        this.setState({reason: evt.target.value});
    }

    submit = () => {
        if(this.state.reason){
            this.props.submitReason(this.state.reason);
        }
        else{
            this.setState({error: true});
        }
    }

    render() {
        return (
            <div style={{
                position: "fixed",
                top: "5vh",
                left: "50%",
                zIndex: 1000,
                padding: "50px",
                backgroundColor: "white",
                border: "2px solid black",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-evenly",
                gap: "16px",
                transform: "translateX(-50%)"
            }}>
                <div>
                    <label htmlFor="delay_reason_textarea">Please state the reason </label>
                    {
                        this.state.error
                        ? <span style={{color: "red"}}> *required</span>
                        : null
                    }
                </div>
                <textarea id="delay_reason_textarea" ref={this.textRef} rows="8" value={this.state.reason} onChange={this.change}>
                </textarea>
                <button className="option" onClick={this.submit}>Submit</button>
            </div>
        )
    }
}